// Copyright (c) 2019 Deere & Company

import { readLatestPerUnitMeasurements, resetLatestPerUnitMeasurements } from '../../shared/action-creators/latest-per-unit-measurements';
import { resetAccountLookup, updateAccountLookup } from '../../new-transfer/action-creators/account-lookup';
import { resetProductDetails, updateProduct } from '../../new-transfer/action-creators/product';
import { createTransfer } from '../../new-transfer/action-creators/create-new-transfer';
import dealerSearchActionCreators from '../../dealer-search/action-creators';
import { goToPreviousView } from '../../shared/action-creators/go-to-previous-view';
import { goToStatusChangeRequestView } from '../../shared/action-creators/status-change-request-view';
import { pinSearchData } from './pin-search-data';
import { readDealer } from '../../new-transfer/action-creators/read-dealer';
import { resetNewTransfer } from '../../new-transfer/action-creators/reset-new-transfer';
import { resetPinSearchData } from './reset-pin-search-data';
import { updateAmountOfUseModalVisibility } from '../../new-transfer/action-creators/amount-of-use-modal-visibility';
import { updateDealerSearchModalVisibility } from '../../new-transfer/action-creators/dealer-search-modal';
import { updateNewTransfer } from '../../new-transfer/action-creators/update-new-transfer';
import { updateNewTransferNewDealer } from '../../new-transfer/action-creators/update-new-dealer';
import { updateNewTransferStatusChangeModal } from '../../new-transfer/action-creators/new-transfer-status-change-modal';
import { updateReasonForChange } from '../../new-transfer/action-creators/update-reason-for-change';

export default {
    ...dealerSearchActionCreators,
    createTransfer,
    goToPreviousView,
    goToStatusChangeRequestView,
    pinSearchData,
    readDealer,
    readLatestPerUnitMeasurements,
    resetAccountLookup,
    resetLatestPerUnitMeasurements,
    resetNewTransfer,
    resetPinSearchData,
    resetProductDetails,
    updateAccountLookup,
    updateAmountOfUseModalVisibility,
    updateDealerSearchModalVisibility,
    updateNewTransfer,
    updateNewTransferNewDealer,
    updateNewTransferStatusChangeModal,
    updateProduct,
    updateReasonForChange,

};
